/**
 * Store GET /api/v1/store/employee/get?include_invited=true returns `invited[]` where
 * person fields live under `employee_data`. Flatten for forms and list rows.
 */
export function flattenStoreInviteForForm(
    data: Record<string, unknown> | null | undefined,
): Record<string, unknown> | null {
    if (!data || typeof data !== 'object') return data ?? null;
    const ed = data.employee_data;
    if (ed && typeof ed === 'object' && !Array.isArray(ed)) {
        return { ...(ed as Record<string, unknown>), ...data };
    }
    return data;
}

/** Map one raw `invited` API item into the shape used by employee settings list + modal. */
export function mapStoreInvitedEmployeeRow(invite: unknown, t: (key: string) => string): Record<string, unknown> {
    const inv = invite && typeof invite === 'object' ? { ...(invite as Record<string, unknown>) } : {};
    const ed =
        inv.employee_data && typeof inv.employee_data === 'object' && !Array.isArray(inv.employee_data)
            ? { ...(inv.employee_data as Record<string, unknown>) }
            : {};
    return {
        ...inv,
        ...ed,
        invitation_id: inv.id,
        invite_pending: true,
        label: `${String(ed.name ?? '')} (${t('Setting.PendingInvitation')})`,
        value: inv.id,
        permission: {},
        selectedEmployee: false,
    };
}
